import { ReactComponent as Logo } from '../../assets/icons/mute 1.svg'

const VolumnMute = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default VolumnMute
